import React, { Fragment } from "react";
import type { Variants } from "framer-motion";
import { Dialog, Transition } from "@headlessui/react";
import { AnimatePresence, motion } from "framer-motion";
import { cn } from "../../utils/cn";
import { fleetrifyIcons } from "../../assets/icons/icons";

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children?: React.ReactNode;
  titleClassName?: string;
  disableClose?: boolean;
  enableOutsideClickClose?: boolean;
}

export const FleetrifyDrawer: React.FC<DrawerProps> = ({
  isOpen,
  onClose,
  title,
  children,
  titleClassName,
  disableClose,
  enableOutsideClickClose,
}) => {
  // const drawerVariants = {
  //   hidden: { x: "100%" },
  //   visible: {
  //     x: 0,
  //     transition: { type: "spring", stiffness: 300, damping: 30 },
  //   },
  //   exit: {
  //     x: "100%",
  //     transition: { type: "tween", duration: 1.2, ease: "easeInOut" },
  //   },
  // };

  const drawerVariants: Variants = {
    hidden: { x: "100%" },
    visible: {
      x: 0,
      transition: { type: "spring" as const, stiffness: 300, damping: 30 },
    },
    exit: {
      x: "100%",
      transition: { type: "tween" as const, duration: 1.2, ease: "easeInOut" },
    },
  };
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-[9999]"
        onClose={enableOutsideClickClose !== false ? onClose : () => { }}
      >
        <AnimatePresence>
          {isOpen && (
            <>
              {/* Overlay (simple fade) */}
              <Transition.Child as={Fragment}>
                <motion.div
                  className="fixed inset-0 bg-black/50 backdrop-blur-sm"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.3 }}
                />
              </Transition.Child>

              {/* Drawer Panel */}
              <div className="fixed inset-0 overflow-hidden p-4 sm:p-10 flex justify-end items-center">
                <motion.div
                  className="relative w-full max-w-md h-[100%] bg-white rounded-xl shadow-2xl overflow-hidden flex flex-col"
                  key="drawer"
                  variants={drawerVariants}
                  initial="hidden"
                  animate="visible"
                  exit="exit"
                >
                  <Dialog.Panel className="w-full h-full flex flex-col">
                    {/* Header */}
                    <div className="flex items-center px-6 py-2 bg-[#14388733] justify-between border-b flex-shrink-0">
                      <h2
                        className={cn(
                          "text-[13px] font-bold text-black",
                          titleClassName
                        )}
                      >
                        {title}
                      </h2>
                      {!disableClose && (
                        <button
                          onClick={onClose}
                          className="bg-white rounded-[4px] h-[24px] w-[24px] grid place-items-center"
                          aria-label="Close modal"
                        >
                          <figure>{fleetrifyIcons.cancelIcon}</figure>
                        </button>
                      )}
                    </div>

                    {/* Body - scroll only here */}
                    <div className="p-6 overflow-y-auto flex-1 hide-scrollbar">
                      {children}
                    </div>
                  </Dialog.Panel>
                </motion.div>
              </div>
            </>
          )}
        </AnimatePresence>
      </Dialog>
    </Transition.Root>

  );
};
